/** White-on-transparent logo, so it needs a dark background to be visible. */
export const BRAND_ICON_THUMBNAIL_URL =
	"/logos/brookbush-institute-logo-icon.png";

/**
 * Classes for a landing-page feature thumbnail and its frame.
 *
 * @param {string} url - Thumbnail image URL
 * @returns {{ container: string; image: string }} Frame and image classes
 */
export const getFeatureThumbnailClassNames = (
	url: string,
): { container: string; image: string } =>
	url === BRAND_ICON_THUMBNAIL_URL
		? { container: "bg-black", image: "object-contain p-8" }
		: { container: "", image: "object-cover" };
